const VOTER_KEY = "kerala_cm_voter_id";

export function getOrCreateVoterId() {
  let id = localStorage.getItem(VOTER_KEY);
  if (!id) {
    // RFC4122 v4-ish — uses crypto.randomUUID when available
    id = (typeof crypto !== "undefined" && crypto.randomUUID)
      ? crypto.randomUUID()
      : "v-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(VOTER_KEY, id);
  }
  return id;
}

const VOTED_KEY = "kerala_cm_voted_for";

export function getLocalVote() {
  return localStorage.getItem(VOTED_KEY);
}

export function setLocalVote(candidateId) {
  localStorage.setItem(VOTED_KEY, candidateId);
}
